<template>
  <div>
    <el-form ref="form" :model="form" :rules="formRules" label-width="80px" label-position="left">
      <el-row gutter="20">
        <el-col span="12">
          <el-form-item label="管理区域" prop="communityId">
            <el-select
              v-model="form.communityId"
              placeholder="请选择"
              style="width: 100%"
              :disabled="id"
            >
              <el-option
                v-for="(e, i) in nodes"
                :key="i"
                :label="e.title"
                :value="e.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="费用科目" prop="subjectId">
            <!--  -->
            <el-select v-if="!id" v-model="form.subjectId" placeholder="请选择" style="width: 100%">
              <template  v-for="(e, i) in subjects">
              <el-option
                v-if="e.status==1"
                :key="i"
                :label="e.name"
                :value="e.id"
              ></el-option>
              </template>
            </el-select>
            <!--  -->
            <el-select
              v-if="id"
              v-model="form.subjectName"
              placeholder="请选择"
              style="width: 100%"
              :disabled="true"
            >
            </el-select>
            <!--  -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="20">
        <el-col span="12">
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="form.name"
              style="width: 100%"
              show-word-limit
              maxlength="50"
              :disabled="id"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="费用精度" prop="feePrecision">
            <el-radio-group v-model="form.feePrecision" :disabled="id">
              <el-radio
                v-for="(item, index) in dicts.fee_standard_precision"
                :key="index"
                :label="item.dictKey"
                >{{ item.dictValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="20">
        <el-col span="12">
          <el-form-item label="圆整方式" prop="roundWay">
            <el-select
              v-model="form.roundWay"
              placeholder="请选择"
              style="width: 100%"
              :disabled="id"
            >
              <el-option
                v-for="(item, index) in dicts.fee_standard_round_way"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="生效时间" prop="startTime">
            <el-date-picker
              v-model="form.startTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
              :disabled="id"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="20">
        <el-col span="12">
          <el-form-item label="失效时间" prop="endTime">
            <el-date-picker
              v-model="form.endTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
              :disabled="id"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status" :disabled="id">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="0">无效 </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="15">
          <el-form-item label="计费方式" prop="feeWay">
            <el-radio-group v-model="form.feeWay" :disabled="id">
              <el-radio
                v-for="(item, index) in dicts.fee_standard_cal_way"
                :key="index"
                :label="item.dictKey"
                >{{ item.dictValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col span="9">
          <el-form-item label="标准说明">
            <el-input
              v-model="form.remark"
              show-word-limit
              maxlength="100"
              :disabled="id"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- extendForm -->
      <template v-if="dicts.fee_standard_cal_way && dicts.fee_standard_cal_way">
        <AddExtendArea
          ref="extend"
          v-if="form.feeWay == dicts.fee_standard_cal_way[0].dictKey"
          :form="areaForm"
          :dicts="dicts"
          :id="id"
        />
        <AddExtendAmount
          ref="extend"
          v-if="form.feeWay == dicts.fee_standard_cal_way[1].dictKey"
          :form="amountForm"
          :dicts="dicts"
          :id="id"
        />
        <AddExtendReading
          ref="extend"
          v-if="form.feeWay == dicts.fee_standard_cal_way[2].dictKey"
          :form="readingForm"
          :dicts="dicts"
          :id="id"
        />
        <AddExtendOther
          ref="extend"
          v-if="form.feeWay == dicts.fee_standard_cal_way[3].dictKey"
          :form="otherForm"
          :dicts="dicts"
          :id="id"
        />
        <!--  -->
        <div v-if="form.feeWay != dicts.fee_standard_cal_way[3].dictKey">
          <el-form-item label-width="0px">
            <el-checkbox v-model="feeCycleChecked" :disabled="id">应收日期管理</el-checkbox>
          </el-form-item>
          <el-row v-if="feeCycleChecked">
            <el-col span="1"></el-col>
            <el-col span="20">
              <el-row gutter="10">
                <el-col span="8">
                  <el-form-item label="支付周期" prop="cycleType">
                    <el-select
                      v-model="form.cycleType"
                      placeholder="请选择"
                      style="width: 100%"
                      :disabled="id"
                    >
                      <el-option
                        v-for="(e, i) in dicts.fee_standard_cycle_type"
                        :key="i"
                        :label="e.dictValue"
                        :value="e.dictKey"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col span="4" v-if="form.cycleType == 1">
                  <el-form-item prop="cycleNum" label-width="0px">
                    <el-input
                      v-model="form.cycleNum"
                      type="text"
                      :disabled="id"
                      :show-word-limit="true"
                      maxlength="4"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="2" v-if="form.cycleType == 1" class="gutter-word">(个)</el-col>
                <el-col span="4" v-if="form.cycleType == 1">
                  <el-form-item label-width="0px">
                    <el-select
                      v-model="form.cycleUnit"
                      placeholder="请选择"
                      style="width: 100%"
                      :disabled="id"
                    >
                      <el-option
                        v-for="(e, i) in dicts.fee_standard_cycle_unit"
                        :key="i"
                        :label="e.dictValue"
                        :value="e.dictKey"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="支付周期开始时间" label-width="140px" prop="cycleStartRule">
                <el-row gutter="10">
                  <el-col span="10">
                    <el-select
                      v-model="form.cycleStartRule"
                      placeholder="请选择"
                      style="width: 100%"
                      :disabled="id"
                    >
                      <el-option
                        v-for="(e, i) in dicts.fee_standard_cycle_start_rule"
                        :key="i"
                        :label="e.dictValue"
                        :value="e.dictKey"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="账单生成颗粒" label-width="120px" prop="billGenerateRule">
                <el-row gutter="10">
                  <el-col span="10">
                    <el-select
                      v-model="form.billGenerateRule"
                      placeholder="请选择"
                      style="width: 100%"
                      :disabled="id"
                    >
                      <el-option
                        v-for="(e, i) in dicts.fee_standard_bill_generate_rule"
                        :key="i"
                        :label="e.dictValue"
                        :value="e.dictKey"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="按起算日期提前" label-width="120px" prop="billGenerateAdvance">
                <el-row gutter="10">
                  <el-col span="4">
                    <el-input
                      type="text"
                      v-model="form.billGenerateAdvance"
                      style="width: 100%"
                      :disabled="id"
                      :show-word-limit="true"
                      maxlength="4"
                    ></el-input>
                  </el-col>
                  <el-col span="8"> 个月生成账单 </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <!--  -->
          <el-form-item label-width="0px">
            <el-checkbox v-model="delayChecked" :disabled="id">违约金设置</el-checkbox>
          </el-form-item>
          <el-row v-if="delayChecked">
            <el-col span="1"></el-col>
            <el-col span="20">
              <el-row gutter="10">
                <el-col span="8">
                  <el-form-item label="起算日期" prop="delayStartType">
                    <el-select
                      v-model="form.delayStartType"
                      placeholder="请选择"
                      style="width: 100%"
                      :disabled="id"
                    >
                      <el-option
                        v-for="(e, i) in dicts.fee_standard_delay_start_type"
                        :key="i"
                        :label="e.dictValue"
                        :value="e.dictKey"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col span="2" class="gutter-word"> 之后 </el-col>
                <el-col span="4">
                  <el-form-item prop="delayBeginDays" label-width="0">
                    <el-input
                      v-model="form.delayBeginDays"
                      type="text"
                      style="width: 100%"
                      :disabled="id"
                      maxlength="4"
                      :show-word-limit="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="5" class="gutter-word"> 天开始计算滞纳金 </el-col>
              </el-row>
              <el-form-item label="每天收取比例" label-width="120px" prop="delayRate">
                <el-row gutter="10">
                  <el-col span="8">
                    <el-input
                      type="text"
                      v-model="form.delayRate"
                      style="width: 100%"
                      :disabled="id"
                      maxlength="10"
                      :show-word-limit="true"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-form>
    <el-row type="flex" justify="end" v-if="!id">
      <el-button type="primary" icon="el-icon-plus" @click="save">保存</el-button>
      <el-button icon="el-icon-close" @click="cancel">取消</el-button>
    </el-row>
  </div>
</template>


<script>
import dayjs from 'dayjs';
import AddExtendArea from './add-extend-area';
import AddExtendAmount from './add-extend-amount';
import AddExtendReading from './add-extend-reading';
import AddExtendOther from './add-extend-other';

import { save, getDetail } from '@/api/v4ward/fee-standard/index';

import { validation } from '@/util/validation';

export default {
  components: { AddExtendArea, AddExtendAmount, AddExtendReading, AddExtendOther },
  props: {
    dicts: Object,
    subjects: Object,
    nodes: Object,
    id: String,
  },
  data() {
    return {
      form: {
        communityId: '',
        subjectId: '',
        name: '',
        feePrecision: '',
        roundWay: '', //圆整方式
        startTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().add(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
        status: 1,
        feeWay: '',
        remark: '',
        cycleType: '',
        cycleNum: '',
        cycleUnit: '',
        cycleStartRule: '',
        billGenerateRule: '',
        billGenerateAdvance: '',
        delayStartType: '',
        delayRate: '',
        delayBeginDays: '',
      },
      formRules: {
        communityId: [{ required: true, message: '请选择管理区域', trigger: 'blur' }],
        subjectId: [{ required: true, message: '请选择费用科目', trigger: 'blur' }],
        name: [
          { required: true, message: '请输入名称', trigger: 'change' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'change' },
        ],
        feePrecision: [{ required: true, message: '请选择日期', trigger: 'change' }],
        roundWay: [{ required: true, message: '请选择圆整方式', trigger: 'change' }],
        startTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        feeWay: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        cycleType: [{ required: true, message: '请选择支付周期', trigger: 'blur' }],
        cycleNum: [
          { required: true, message: '请输入支付周期数量', trigger: 'blur' },
          { validator: validation.digit(1, 4), trigger: 'change' },
        ],
        cycleStartRule: [{ required: true, message: '请选择', trigger: 'blur' }],
        billGenerateRule: [{ required: true, message: '请选择', trigger: 'blur' }],
        billGenerateAdvance: [
          { required: true, message: '请输入提前月份', trigger: 'blur' },
          { validator: validation.digit(1, 4), trigger: 'change' },
        ],
        delayStartType: [{ required: true, message: '请选择', trigger: 'blur' }],
        delayBeginDays: [
          { required: true, message: '请输入起算天数', trigger: 'blur' },
          { validator: validation.digit(1, 4), trigger: 'change' },
        ],
        delayRate: [
          { required: true, message: '请输入滞纳金比率', trigger: 'blur' },
          {
            validator: (rule, value, cb) => {
              let temp = /^1(\.0+)?$|^0(\.\d+)$/.test(value + '');
              if (!temp) {
                cb(new Error('比率错误'));
              } else {
                cb();
              }
            },
            trigger: 'change',
          },
        ],
      },
      areaForm: {
        pricingModel: '1',
        feePrice: '',
        feeUnit: '',
        lessMonthWay: '',
        lessMonthDaysWay: '',
        areaSize: '1',
      },
      amountForm: {
        pricingModel: '1', //定价模式
        feePrice: '', //算费费率(费用)
        feeUnit: '',
        lessMonthWay: '',
        lessMonthDaysWay: '',
      },
      readingForm: {
        pricingModel: '1',
        feePrice: '',
        feeUnit: '',
        meterBig: '',
        meterSmall: '',
        priceRange: [{ startLevel: '', endLevel: '', amount: '', unit: '' }],
      },
      otherForm: {
        pricingModel: '1',
        feePrice: '',
        feeUnit: '',
      },
      feeCycleChecked: true,
      delayChecked: true,
    };
  },
  methods: {
    checkStartAndEndTime() {
      let start = dayjs(this.form.startTime);
      let end = dayjs(this.form.endTime);
      return start.isBefore(end);
    },
    async save() {
      let loading;
      console.log('this.$refs==>', this.$refs);
      try {
        let valiFrom = await this.$refs.form.validate();
        let valiExtend = await this.$refs.extend.validate();
        if (valiFrom && valiExtend) {
          //处理json
          this.areaForm.pricingJson = JSON.stringify({
            areaSize: this.areaForm.areaSize,
          });
          this.readingForm.pricingJson = JSON.stringify({
            meterBig: this.readingForm.meterBig,
            meterSmall: this.readingForm.meterSmall,
            priceRange: this.readingForm.priceRange,
          });
          this.otherForm.pricingJson = JSON.stringify({});
          this.amountForm.pricingJson = JSON.stringify({});
          //
          let extend = null;
          switch (this.form.feeWay) {
            case '1':
              extend = this.areaForm;
              break;
            case '2':
              extend = this.amountForm;
              break;
            case '3':
              extend = this.readingForm;
              break;
            case '99':
              extend = this.otherForm;
              break;
          }
          const postData = { ...this.form, ...extend };
          //fix
          let startTime = dayjs(this.form.startTime);
          let endTime = dayjs(this.form.endTime);
          if (endTime.isBefore(startTime)) {
            this.$message({
              message: '生效时间需要大于失效时间',
              type: 'warning',
            });
            return;
          }
          //
          loading = this.$loading();
          let res = await save(postData);
          loading.close();
          if (res.success) {
            this.$message({
              message: '操作成功',
              type: 'success',
            });
          }
          this.$emit('closeDialog', true);
        }
      } catch (err) {
        console.log('err==>', err);
        loading.close();
      }
    },
    cancel() {
      this.$emit('closeDialog');
    },
    setInitValue() {
      setTimeout(() => {
        let subjectId = ''
        for(let i=0;i<this.subjects.length;i++){
          if(this.subjects[i].status==1){
            subjectId = this.subjects[i].id;
            break
          }
        }
       
        this.form = Object.assign({}, this.form, {
          communityId: this.nodes && this.nodes[0].id,
          subjectId,
          feePrecision: this.dicts.fee_standard_precision[0].dictKey,
          roundWay: this.dicts.fee_standard_round_way[0].dictKey,
          feeWay: this.dicts.fee_standard_cal_way[0].dictKey,
          cycleType: this.dicts.fee_standard_cycle_type[1].dictKey,
          cycleUnit: this.dicts.fee_standard_cycle_unit[0].dictKey,
          cycleStartRule: this.dicts.fee_standard_bill_generate_rule[0].dictKey,
          billGenerateRule: this.dicts.fee_standard_cycle_start_rule[0].dictKey,
          delayStartType: this.dicts.fee_standard_delay_start_type[0].dictKey,
        });
      });
    },
  },
  created() {
    if (this.id) {
      getDetail({ id: this.id }).then((res) => {
        console.log('res==>', res);
        let pricingJson = res.data.pricingJson && JSON.parse(res.data.pricingJson);
        this.form = { ...res.data, ...pricingJson };
        this.areaForm = this.form;
        this.amountForm = this.form;
        this.readingForm = this.form;
        this.otherForm = this.form;
      });
    } else {
      this.setInitValue();
    }
  },
};
</script>
<style lang="scss" scoped>
.gutter-word {
  height: 32px;
  line-height: 32px;
  text-align: center;
}
</style>